import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../theme";
import {
  useAddOrderMutation,
  useInitRazorPayForUserMutation,
  useRecordPaymentMutation,
} from "../features/auth/apiSlice";
import { Formik } from "formik";
import * as yup from "yup";

const phoneRegExp = /^[6-9]\d{9}$/;
const userSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  address1: yup.string().required("required"),
  address2: yup.string().required("required"),
  PINCode: yup.string().required("required"),
  HouseOrFlatNo: yup.string().required("required"),
});

const Cart = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const props = location.state;
  const [cart, setCart] = useState([] as any);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalSubTotal, setTotalSubTotal] = useState(0);
  const [initializeRazorpayAPI] = useInitRazorPayForUserMutation();
  const [recordPaymentAPI] = useRecordPaymentMutation();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    address1: "",
    address2: "",
    PINCode: "",
    HouseOrFlatNo: "",
  });
  const [showAddress, setShowAddress] = useState(false);
  const [orderAPI] = useAddOrderMutation();
  const [name, setName] = useState("");
  const __Dev__ = document.domain === "localhost";
  const navigate = useNavigate();

  const loadRazorpay = (src: string) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      document.body.appendChild(script);
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        reject(true);
      };
    });
  };

  const displayRazorpay = async (orderId: string) => {
    const response: any = await loadRazorpay(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!response) {
      console.log("Razorpay SDK failed to load are you online");
      return;
    }

    const razorpayResponse: any = await initializeRazorpayAPI({
      sponserId: props.sponserId,
      landingPageId: props.landingPageId,
      orderId: orderId,
    }).unwrap();

    const options = {
      //TODO add production api
      key: __Dev__ ? "rzp_test_b6eM0MKyD4lhO5" : "Production API", // Enter the Key ID generated from the Dashboard
      amount: razorpayResponse.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: razorpayResponse.currency,
      name: name, //your business name
      description: "Cart Transation",
      image: "",
      order_id: razorpayResponse.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      // callback_url: "http://localhost:3000/invoices",
      handler: async (response: any) => {
        const recordPaymentResponse: any = await recordPaymentAPI({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          sponserId: props.sponserId,
          orderId: orderId,
        }).unwrap();
        if (recordPaymentResponse.status === 200) {
          navigate("/orders", { state: { home: props.home } });
          localStorage.setItem("cart", JSON.stringify([]));
          localStorage.setItem("orders", JSON.stringify(cart));
        }
      },
    };

    const _window = window as any;
    var paymentObject = new _window.Razorpay(options);
    paymentObject.open();
  };

  useEffect(() => {
    setCart(JSON.parse(localStorage.getItem("cart") as string));
  }, []);

  useEffect(() => {
    let p = 0;
    let q = 0;
    let sub = 0;
    cart.forEach((item: any) => {
      p += item.price;
      q += item.quantity;
      sub += item.price * item.quantity;
    });
    setTotalPrice(p);
    setTotalQuantity(q);
    setTotalSubTotal(sub);
  }, [cart]);

  const Row = ({ item }: { item: any }) => {
    const handleSubClicked = (item: any) => {
      if (item.quantity <= 1) {
        return;
      }
      const updatedCart = cart.map((i: any) => {
        if (i._id === item._id) {
          return { ...i, quantity: i.quantity - 1 };
        }
        return { ...i };
      });
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      setCart(updatedCart);
    };
    const handleAddClicked = (item: any) => {
      const updatedCart = cart.map((i: any) => {
        if (i._id === item._id) {
          return { ...i, quantity: i.quantity + 1 };
        }
        return { ...i };
      });
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      setCart(updatedCart);
    };
    const handleRemoveClicked = (item: any) => {
      const updatedCart = cart.filter((i: any) => i._id !== item._id);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      setCart(updatedCart);
    };
    return (
      <tr className="border border-black" key={item._id}>
        <td className="p-5 border border-black">{item.title}</td>
        <td className="p-5 border border-black">{item.price + " Rs/-"}</td>
        <td className="p-5 border border-black">
          <Button variant="contained" onClick={() => handleSubClicked(item)}>
            -
          </Button>
          <span className="ml-2 mr-2">{item.quantity}</span>
          <Button variant="contained" onClick={() => handleAddClicked(item)}>
            +
          </Button>
        </td>
        <td className="p-5 border border-black">
          {item.price * item.quantity + " Rs/-"}
        </td>
        <td className="p-5 border border-black">
          <Button
            onClick={() => handleRemoveClicked(item)}
            variant="contained"
            style={{ backgroundColor: "red" }}
          >
            Remove
          </Button>
        </td>
      </tr>
    );
  };

  const handleFormSubmit = async (values: any) => {
    setName(values.firstName + " " + values.lastName);
    const response: any = await orderAPI({
      ...values,
      sponserId: props.sponserId,
      landingPageId: props.landingPageId,
      products: cart,
    }).unwrap();
    if (response.status === 200) {
      //initiate payment
      displayRazorpay(response.orderId);
    }
  };

  const handleNextClicked = async () => {
    setShowAddress(true);
  };

  return (
    <div>
      <header>
        <nav
          className="flex justify-between p-2"
          style={{ backgroundColor: colors.blueAccent[300] }}
        >
          <div>
            <Link to={props?.home}>Home</Link>
          </div>
        </nav>
      </header>
      <main>
        <div className="flex justify-center">
          <div>
            {!showAddress ? (
              <>
                <table className="border border-black mt-5">
                  <thead>
                    <tr className="border border-black">
                      <th className="p-5 border border-black text-start">
                        Title
                      </th>
                      <th className="p-5 border border-black text-start">
                        Price
                      </th>
                      <th className="p-5 border border-black text-start">
                        Quantity
                      </th>
                      <th className="p-5 border border-black text-start">
                        Sub Total
                      </th>
                      <th className="p-5 border border-black text-start">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart?.map((item: any) => {
                      return <Row item={item} key={item._id} />;
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="border border-black">
                      <th className="p-2 border border-black text-start">
                        Total:
                      </th>
                      <td className="p-5 border border-black">
                        {totalPrice + " Rs/-"}
                      </td>
                      <td className="p-5 border border-black text-center">
                        {totalQuantity}
                      </td>
                      <td className="p-5 border border-black">
                        {totalSubTotal + " Rs/-"}
                      </td>
                      <td className="p-5 border border-black">
                        <Button
                          variant="contained"
                          style={{ backgroundColor: "red" }}
                          onClick={() => {
                            setCart([]);
                            localStorage.setItem("cart", JSON.stringify([]));
                          }}
                        >
                          Remove All
                        </Button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div
                  className="flex justify-between items-center "
                  style={{ marginTop: "12px" }}
                >
                  <Typography variant="h4">
                    Proceed to pay {totalSubTotal} Rs/-
                  </Typography>
                  <Button variant="contained" onClick={handleNextClicked}>
                    Next
                  </Button>
                </div>
              </>
            ) : (
              <div
                className="flex justify-center items-center "
                style={{ marginTop: "12px", marginBottom: "12px" }}
              >
                <Formik
                  onSubmit={handleFormSubmit}
                  initialValues={initialValues}
                  validationSchema={userSchema}
                >
                  {/* @ts-ignore */}
                  {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => {
                    return (
                      <form
                        onSubmit={handleSubmit}
                        className="border border-black p-2 rounded"
                      >
                        <Box
                          display={"grid"}
                          gap="30px"
                          gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                          sx={{
                            "& > div": {
                              gridColumn: isNonMobile ? undefined : "span 4",
                            },
                          }}
                        >
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="First Name"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                firstName: e.target.value,
                              });
                            }}
                            value={initialValues.firstName}
                            name="firstName"
                            error={!!touched.firstName && !!errors.firstName}
                            helperText={touched.firstName && errors.firstName}
                            sx={{ gridColumn: "span 2" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="Last Name"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                lastName: e.target.value,
                              });
                            }}
                            value={initialValues.lastName}
                            name="lastName"
                            error={!!touched.lastName && !!errors.lastName}
                            helperText={touched.lastName && errors.lastName}
                            sx={{ gridColumn: "span 2" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="E-Mail"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                email: e.target.value,
                              });
                            }}
                            value={initialValues.email}
                            name="email"
                            error={!!touched.email && !!errors.email}
                            helperText={touched.email && errors.email}
                            sx={{ gridColumn: "span 2" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"number"}
                            label="Contact Number"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                contact: e.target.value,
                              });
                            }}
                            value={initialValues.contact}
                            name="contact"
                            error={!!touched.contact && !!errors.contact}
                            helperText={touched.contact && errors.contact}
                            sx={{ gridColumn: "span 2" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="Address 1"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                address1: e.target.value,
                              });
                            }}
                            value={initialValues.address1}
                            name="address1"
                            error={!!touched.address1 && !!errors.address1}
                            helperText={touched.address1 && errors.address1}
                            sx={{ gridColumn: "span 4" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="Address 2"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                address2: e.target.value,
                              });
                            }}
                            value={initialValues.address2}
                            name="address2"
                            error={!!touched.address2 && !!errors.address2}
                            helperText={touched.address2 && errors.address2}
                            sx={{ gridColumn: "span 4" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"number"}
                            label="PIN Code"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                PINCode: e.target.value,
                              });
                            }}
                            value={initialValues.PINCode}
                            name="PINCode"
                            error={!!touched.PINCode && !!errors.PINCode}
                            helperText={touched.PINCode && errors.PINCode}
                            sx={{ gridColumn: "span 2" }}
                          />
                          <TextField
                            fullWidth
                            variant="filled"
                            type={"text"}
                            label="House / Flat No"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                HouseOrFlatNo: e.target.value,
                              });
                            }}
                            value={initialValues.HouseOrFlatNo}
                            name="HouseOrFlatNo"
                            error={
                              !!touched.HouseOrFlatNo && !!errors.HouseOrFlatNo
                            }
                            helperText={
                              touched.HouseOrFlatNo && errors.HouseOrFlatNo
                            }
                            sx={{ gridColumn: "span 2" }}
                          />
                        </Box>
                        <div className="flex justify-center mt-5">
                          <Button variant="contained" type="submit">
                            Create Order
                          </Button>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </div>
            )}
          </div>
        </div>
      </main>
      <footer></footer>
    </div>
  );
};

export default Cart;
